import React, { useEffect, useState } from 'react'
import { Loader } from '../../../Basic/components';
import { getCommonParams, pageNumberToReactPaginateIndex, reactPaginateIndexToPageNumber, substract } from '../../../Utils/helper';
import ReactPaginate from 'react-paginate';
import { showEntries } from '../../../Utils/DropdownData';
import { useGetOnlineSalesDeliveryQuery } from '../../../redux/ErpServices/onlineSalesDeliveryServices';

const OnlineSalesItemsFillGrid = ({ productionDeliveryDetails, setProductionDeliveryDetails, setFillGrid, id }) => {
    const [localProductionDeliveryDetails, setLocaProductionDeliveryDetails] = useState(productionDeliveryDetails);

    const [searchStyleNo, setSearchStyleNo] = useState("");
    const [searchDeliveryNo, setSearchDeliveryNo] = useState("")

    function handleDone() {
        setProductionDeliveryDetails(localProductionDeliveryDetails);
        setFillGrid(false);
    }
    const { branchId } = getCommonParams()

    const [dataPerPage, setDataPerPage] = useState("10");
    const [totalCount, setTotalCount] = useState(0);
    const [currentPageNumber, setCurrentPageNumber] = useState(1);


    const { data, isFetching, isLoading } = useGetOnlineSalesDeliveryQuery({
        params: {
            itemWise: true,
            pagination: true,
            branchId,
            dataPerPage, pageNumber: currentPageNumber, onlineSalesReturnId: id, searchStyleNo, searchDocId: searchDeliveryNo
        }
    })
    useEffect(() => {
        if (data?.totalCount) {
            setTotalCount(data?.totalCount)
        }
    }, [data, isLoading, isFetching])
    if (!data?.data || isFetching || isLoading) return <Loader />

    function addItem(item) {
        setLocaProductionDeliveryDetails(localInwardItems => {
            let newItems = structuredClone(localInwardItems);
            newItems.push(item);
            return newItems
        });
    }
    function removeItem(removeItem) {
        setLocaProductionDeliveryDetails(localInwardItems => {
            return localInwardItems.filter(item =>
                !(parseInt(item.onlineSalesDetailsId) === parseInt(removeItem.onlineSalesDetailsId))
            )
        });
    }

    function isItemChecked(checkItem) {
        let item = localProductionDeliveryDetails.find(item =>
            (parseInt(item.onlineSalesDetailsId) === parseInt(checkItem.onlineSalesDetailsId))
        )
        if (!item) return false
        return true
    }


    function handleCheckBoxChange(value, item) {
        if (value) {
            addItem(item)
        } else {
            removeItem(item)
        }
    }

    function handleSelectAllChange(value) {
        if (value) {
            (data?.data ? data.data : []).forEach(item => addItem({ onlineSalesDetailsId: item.id }))
        } else {
            (data?.data ? data.data : []).forEach(item => removeItem({ onlineSalesDetailsId: item.id }))
        }
    }

    function getSelectAll() {
        return (data?.data ? data.data : []).every(item => isItemChecked({ onlineSalesDetailsId: item.id }))
    }


    return (
        <div>
            <div className={`bg-gray-200 z-50 overflow-auto w-[1000px]`}>
                <div className="md:flex md:items-center md:justify-between page-heading p-1">
                    <div className="heading text-center md:mx-10 text-xs"> Online Sales Items</div>
                    <div className=" sub-heading justify-center md:justify-start items-center">
                        <label className="text-white text-xs rounded-md m-1  border-none">Show Entries</label>
                        <select value={dataPerPage}
                            onChange={(e) => setDataPerPage(e.target.value)} className='h-6 w-40 border border-gray-500 rounded mr-9'>
                            {showEntries.map((option) => <option value={option.value} >{option.show}</option>)}
                        </select>
                    </div>
                </div>
                <table className="border border-gray-500 w-full text-xs text-start">
                    <thead className="border border-gray-500">
                        <tr>
                            <th className='w-8 p-5'>
                                Mark All
                                <input type="checkbox" className='w-full' onChange={(e) => handleSelectAllChange(e.target.checked)}
                                    checked={getSelectAll()}
                                />
                            </th>
                            <th className="w-20 border border-gray-500">S.no</th>
                            <th className="border border-gray-500">
                                <div className='grid h-full items-center justify-center'>
                                    <span>
                                        Delivery No.
                                    </span>
                                    {/* <input type="text" autoFocus className='w-[90%] border border-gray-600' value={searchDeliveryNo} onChange={(e) => setSearchDeliveryNo((e.target.value).toUpperCase())} /> */}
                                </div>
                            </th>
                            <th className="border border-gray-500">
                                <div className='grid h-full items-center justify-center'>
                                    <span>
                                        Style
                                    </span>
                                    <input type="text" autoFocus className='w-[90%] border border-gray-600' value={searchStyleNo} onChange={(e) => setSearchStyleNo((e.target.value).toUpperCase())} />
                                </div>
                            </th>
                            <th className="border border-gray-500">Color</th>
                            <th className="border border-gray-500">Size</th>
                            <th className="border border-gray-500">Sales Qty</th>
                            <th className="border border-gray-500">A. Return Qty</th>
                            <th className="border border-gray-500">Bal. Qty</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(data?.data ? data?.data : []).filter(item => substract(item.qty, item.aReturnQty) > 0).map((item, index) =>
                            <tr key={index} className='table-row' onClick={() => {
                                handleCheckBoxChange(!isItemChecked({ onlineSalesDetailsId: item.id }), { onlineSalesDetailsId: item.id, qty: 0 })
                            }}>
                                <td className='table-data'>
                                    <input type="checkbox" className='w-full table-data-input'
                                        checked={isItemChecked({ onlineSalesDetailsId: item.id })} />
                                </td>
                                <td>{index + 1}</td>
                                <td>{item?.OnlineSales?.docId}</td>
                                <td>{item?.Style?.sku}</td>
                                <td className='text-center'>{item?.Color?.name}</td>
                                <td className='text-center'>{item?.Size?.name}</td>
                                <td className='text-right'>{item.qty}</td>
                                <td className='text-right'>{item.aReturnQty}</td>
                                <td className='text-right'>{substract(item.qty, item.aReturnQty)}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <div>
                <ReactPaginate
                    previousLabel={"<"}
                    nextLabel={">"}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    forcePage={pageNumberToReactPaginateIndex(currentPageNumber)}
                    pageCount={Math.ceil(totalCount / dataPerPage)}
                    marginPagesDisplayed={1}
                    onPageChange={(e) => {
                        setCurrentPageNumber(reactPaginateIndexToPageNumber(e.selected));
                    }}
                    containerClassName={"flex justify-center mt-10 gap-5 items-center w-full"}
                    pageClassName={"border custom-circle text-center"}
                    disabledClassName={"p-1 bg-gray-200"}
                    previousLinkClassName={"border p-1 text-center"}
                    nextLinkClassName={"border p-1"}
                    activeClassName={"bg-[#388087] text-white px-2"} />
            </div>
            <div className='flex justify-end'>
                <button className='p-1 bg-blue-400 rounded-lg' onClick={handleDone}>Done</button>
            </div>
        </div>

    )
}

export default OnlineSalesItemsFillGrid;